import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

let proximoId = 0;

/**
 * Ícone "?" com balão de ajuda, no visual do design system Vivest (o design system ainda não
 * tem componente de tooltip). Abre com o mouse ou com o foco do teclado, fecha com Esc e liga o
 * texto ao ícone por `aria-describedby`.
 *
 * @example
 * <app-tooltip-ajuda texto="Exige uma segunda confirmação do participante." />
 */
@Component({
  selector: 'app-tooltip-ajuda',
  standalone: true,
  imports: [],
  templateUrl: './tooltip-ajuda.component.html',
  styleUrl: './tooltip-ajuda.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipAjudaComponent {
  /** Texto de ajuda mostrado no balão. */
  readonly texto = input.required<string>();
  /** Nome acessível do ícone. */
  readonly rotulo = input('Ajuda');

  readonly balaoId = `tooltip-ajuda-${++proximoId}`;
  readonly aberto = signal(false);

  abrir(): void {
    this.aberto.set(true);
  }

  fechar(): void {
    this.aberto.set(false);
  }
}
